(() => {
  // The hosted summary truncates long item titles. Keep the chosen package
  // first in its display name, before the original client signs the request.
  // Product records, identities, amounts and subscription data stay untouched.
  const creationPaths = new Set([
    '/api/checkout', '/api/checkout/credit', '/api/checkout/paypal',
    '/api/checkout/google', '/api/checkout/apple'
  ]);
  const productId = 'gid://shopify/Product/8961235353790';
  const variants = new Set([
    'gid://shopify/ProductVariant/48850413224126',
    'gid://shopify/ProductVariant/48852299317438',
    'gid://shopify/ProductVariant/48852299350206',
    'gid://shopify/ProductVariant/48852299382974'
  ]);
  const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

  const displayBody = (path, body) => {
    if (!creationPaths.has(path) || !isObject(body) || !isObject(body.cart) || !Array.isArray(body.cart.items)) return body;
    let changed = false;
    const items = body.cart.items.map(item => {
      if (!isObject(item) || item.productId !== productId || !variants.has(item.variantId) ||
          typeof item.title !== 'string' || typeof item.variant !== 'string' || !item.variant.trim()) return item;
      const suffix = ' - ' + item.variant;
      if (!item.title.endsWith(suffix)) return item;
      const productTitle = item.title.slice(0, -suffix.length).trim();
      if (!productTitle) return item;
      changed = true;
      return { ...item, title: item.variant + ' — ' + productTitle };
    });
    return changed ? { ...body, cart: { ...body.cart, items } } : body;
  };

  let attempts = 0;
  const install = () => {
    let client;
    try { client = typeof yxRequest === 'undefined' ? null : yxRequest; } catch (_) { client = null; }
    if (!client || typeof client.post !== 'function') {
      if (++attempts < 80) setTimeout(install, 250);
      return;
    }
    if (client.post.corlynaPackageDisplay) return;
    const original = client.post;
    function packageDisplayPost(...args) {
      let next = args;
      try {
        const body = displayBody(args[0], args[1]);
        if (body !== args[1]) { next = args.slice(); next[1] = body; }
      } catch (_) {
        // An unfamiliar body must keep the original checkout behavior.
      }
      return original.apply(this, next);
    }
    Object.defineProperty(packageDisplayPost, 'corlynaPackageDisplay', { value: true });
    client.post = packageDisplayPost;
  };
  install();
})();
